export default __webpack_public_path__ + "d53ee2efb7eb805955b04c08fb468b48.pdf";